import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import Video from 'components/Video';
import NextLink from 'next/link';
import { useStyles } from './styles';
import NavBarOneResearcher from 'components/NavBarOneResearcher';
import getRedirectUrlAfterLogin from 'utils/getRedirectUrlAfterLogin';

export default function Header() {
  const classes = useStyles();

  return (
    <>
      <NavBarOneResearcher localeProp="ja" />

      <Box id="header" className={classes.root}>
        <Container>
          <Box mb={6}>
            <img
              src="/images/mtg-logo-editage.png"
              alt="mind the graph logo"
              width="135"
              height="45"
            />
          </Box>
          <Box className={classes.content}>
            <Box>
              <Typography variant="h4" component="h1">
                効果的な科学イラストを数分で作成
              </Typography>

              <Box py={3}>
                <Typography>
                  視覚的に研究を伝える科学イラストを簡単作成。
                  <br /> 80以上の研究分野をカバーする、
                  <br />
                  70,000 点以上の科学的に正確なイラストから選べます。
                </Typography>
              </Box>

              <NextLink href={getRedirectUrlAfterLogin()} passHref={true}>
                <Button className={classes.button} color="primary" variant="contained">
                  今すぐ作成する
                </Button>
              </NextLink>
            </Box>

            <Box className={classes.videoWrapper}>
              <Video
                className={classes.video}
                sources={[
                  { src: '/videos/new-header-banner-new-workspace.webm', type: 'video/webm' },
                ]}
              />
            </Box>
          </Box>
        </Container>
      </Box>
    </>
  );
}
